import { parse } from 'query-string'

export const captureCoupon = (queryString: string) => {
  const qs = parse(queryString)
  return qs.coupon
}
